<template>
  <v-container v-resize="onResize" style="padding: 0px; max-width: 100%;">
    <v-toolbar  height="70" flat color="indigo" dark dense>
    <v-toolbar-title>Debug</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-select style="margin-top: 0px;margin-right: 10px;width: 100px;height:48px;"  outlined label="Select Server" :items="servers" v-model="server"></v-select>
      <v-select style="margin-top: 0px;padding-right: 10px;width: 100px;height: 48px;" outlined label="Debug Level" :items="levels" v-model="level"></v-select>
      <v-btn raised outlined @click="clear()">Clear</v-btn>
      <!-- <v-icon @click="close">mdi-close</v-icon> -->
    </v-toolbar>
      <div id="container" style=" overflow-y: auto;">
        <v-data-table 
          dense 
          :items="items" 
          item-key="time"
          :headers="headers"
          :items-per-page="20"
        >
        <!-- <template v-slot:group="{ items, expand }">
          <tr @click="toggle(items[0].level)">
            <td  class="text-xs-right"><strong>{{ items[0].level }}</strong></td>
          </tr>
          <tr v-for="(item, index) in items" :key="item.id" v-show="!item.hide">
            <td v-for="header in headers" v-bind:key="header.value" v-show="header.value != 'level'">
              {{ item[header.value] }}
            </td> 
          </tr>
        </template> -->
        </v-data-table>
    <!-- <ul>
      <li v-for="item in items" v-bind:key="item.id">{{ item }}</li>
    </ul> -->
  </div>
  </v-container>
</template>
<script>
import { sync } from 'vuex-pathify'
import moment from 'moment'
import axiosInstances from "@/../../coreui/server/axiosInstances"
export default {
  data: () => ({
    lastheight: 40,
    height: 40,
    windowSize: {
      x: 0,
      y: 0
    },
    mqttNewTopic: null,
    mqttTopic: null,
    items: [],
    headers: [
      {text: 'ID', value: 'id', groupable: false, hide: false},
      {text: 'Time', value: 'time', groupable: false, hide: false},
      {text: 'Level', value: 'level', hide: false},
      {text: 'Module', value: 'module', groupable: false, hide: false},
      {text: 'Message', value: 'message', groupable: false, hide: false},
    ],
    servers: ['FileServer', 'APIServer', 'AuthServer', 'LocalServer'],
    server: 'FileServer',
    levels: ['Debug', 'Info', 'Notice', 'Warning', 'Error', 'Critical'],
    level: 'Debug',
    axiosServer: null
  }),
  computed:{
    mqttClient: sync('mqtt/origMqttClient'),
  },
  watch: {
    mqttNewTopic (val) {
      if (val == null) return
      if (this.mqttTopic != null) {
        this.mqttClient.unsubscribe(this.mqttTopic)
      }
      this.mqttTopic = val
      this.mqttClient.subscribe(val, function (err) {
        if (err) console.log('mqtt subscribe error: ', err)
      })
    },
    server: {
      immediate: true,
      handler (val) {
        this.mqttNewTopic = 'sysdebug/logging/' + val
        this.setServer()
        this.axiosServer.get('/misc/debug?level=' + this.level)
      }
    },
    level: {
      immediate: true,
      handler (val) {
        this.axiosServer.get('/misc/debug?level=' + val)
      }
    }
  },
  methods: {
    toggle (level) {
      console.log('toggling : ', level)
      this.items.forEach(item => {
        if (item.level === level) {
          item.hide = !item.hide
          console.log(item)
        }
      });
    },
    setServer() {
      if (this.server == 'FileServer') {
        this.axiosServer = axiosInstances.fileServer
      } else if (this.server == 'APIServer') {
        this.axiosServer = axiosInstances.apiServer
      } else if (this.server == 'AuthServer') {
        this.axiosServer = axiosInstances.authServer
      } else {
        // default to localhost for testing
        this.axiosServer = axiosInstances.localServer
      }
      this.clear()
    },
    onResize () {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight }
      if (this.windowSize.y != this.lastheight) {
        this.height = this.windowSize.y
        this.lastheight = this.height
      }
    },
    clear () {
      this.items = []
    }
  },
  created () {
    var self = this
    this.mqttClient.on('message', function (topic, message, packet) {
      if (topic !== self.mqttTopic) return
      // console.log('message received: ', topic, this.mqttTopic, message.toString())
      let r = JSON.parse(message.toString())
      r['time'] = moment(r['time']).format('MM/DD/YYYY hh:mm:ss A')
      r['hide'] = false
      self.items.push(r)
    })
  },
  destroyed () {
    if (this.mqttTopic != null) {
      this.mqttClient.unsubscribe(this.mqttTopic)
    }
  },
  mounted () {
    this.mqttNewTopic = 'sysdebug/logging/' + this.server
  }
}
</script>